'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.ui-components.site-header.cb-user-prefs-container', []);

_module.directive('cbUserPrefsContainer', cbUserPrefsContainerDirective);

exports.default = _module;


function cbUserPrefsContainerDirective() {
    return {
        controller: function controller() {
            var vm = this;

            vm.isOpen = false;

            vm.toggle = toggle;

            function toggle() {
                vm.isOpen = !vm.isOpen;
            }
        },
        controllerAs: 'userPrefsContainer'
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/site-header/cb-user-prefs-container.directive.js
// module id = 906
// module chunks = 0